import { ref, reactive, watchEffect, } from "vue";


function useFiltrate(props: any, cxt: any, pitch: Array<Number> = [],active:Number = -1) {
  const unwindList: any = reactive({
    list: [],
  });
  let overlay = ref(false)
  let serviceActive = ref(active);
 console.log('pitch',pitch);
 
  //高亮选中的索引
  let goods_ds: any = reactive({
    list:[]
  });
  if(pitch){
    goods_ds.list = pitch
  }
  //判断是否选择
  let exit;
  let objsData: any = [];
  const diaoyong = () => {
    objsData = [];
    unwindList.list.forEach((element: Object, index: number) => {
      if (goods_ds.list.includes(index)) {
        objsData.push(element);
      }
    });
  };
  let remove_clones = ()=>{
    serviceActive.value = -1   
  }
  let multiple_clones = ()=>{
    goods_ds.list = []
  }
  const categoryClick = (item: Object, value: number, type: string) => {  
    overlay.value = true
    //判断是否单选
    if (props.radioCheck) {
      objsData = [item];
      if(serviceActive.value == value){
        serviceActive.value = -1;       
        cxt.emit("categoryList", '', type + 'empty');
        setTimeout(()=>{
          overlay.value  = false
        },1000)       
      }else{
        serviceActive.value = value;
        cxt.emit("categoryList", objsData, type);
        setTimeout(()=>{
          overlay.value  = false
        },1000)
      }
    } else {
      exit = false;
      if (goods_ds.list && goods_ds.list.includes(value)) {  
        //返回当前点击的索引
        Array.prototype["contains"] = function(obj: Object) {
          var i = this.length;
          while (i--) {
            if (this[i] === obj) {
              return i;
            }
          }
          return false;
        };
        goods_ds.list.splice(goods_ds.list.contains(value), 1);
        diaoyong();
        exit = true;       
        cxt.emit("categoryList", objsData, type);
        setTimeout(()=>{
          overlay.value  = false
        },1000)
      }
      if (!exit) {
        goods_ds.list.push(value);   
        diaoyong();
        cxt.emit("categoryList", objsData, type);
        setTimeout(()=>{
          overlay.value  = false
        },1000)
      }
     
    }
  };

  //数组中是否包含某个值
  let check_goods_exit = (value: Number) => {   
    if (goods_ds.list.includes(value)) {
      return true;
    } else {
      return false;
    }
  };
  //监听数据变化
  watchEffect(() => {
    unwindList.list = props.transferData;
  });

  return {
    categoryClick,
    serviceActive,
    check_goods_exit,
    unwindList,
    goods_ds,
    remove_clones,
    overlay,
    multiple_clones
  };
}

export { useFiltrate };
